/**
* @name: government
* @author: weiyong
* @date: 2023-04-01 21:06
* @description：government
* @update: 2023-04-01 21:06
*/
<template>
  <div :class="prefixCls" class="military wrapper-horizontal">
    <LayoutFeatures/>
    <header-bar-page   :settingLayout="settingLayout"></header-bar-page>

    <div class="page-content  w100b" :class="getShowTabs?'hasTabs':'notTabs'">
      <MultipleTabs class="w100b" v-if="getShowTabs"/>
      <right-layout-div class="w100b"/>
    </div>
    <!--第一层菜单-->
    <left-menu-first/>
    <!-- 右侧菜单明细 -->
    <right-menu-detail/>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";

export default defineComponent({
  components: {
    LayoutFeatures: createAsyncComponent(() => import('@/layouts/default/feature/index.vue')),
  },
  name: "military",
});
</script>

<script lang="ts" setup>
import MultipleTabs from '@/layouts/default/tabs/index.vue';
import RightMenuDetail from "@/layouts/layoutFrame/military/components/right-menu-detail.vue";
import LeftMenuFirst from "@/layouts/layoutFrame/military/components/left-menu-first.vue";
import {useMenuStore} from './viewStore/menuStore';
import HeaderBarPage from "./components/header-bar-page.vue";
import RightLayoutDiv from "./components/right-layout-div.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {computed, ref, unref} from "vue";
import {useI18n} from "@/hooks/web/useI18n";
import {useFullContent} from "@/hooks/web/useFullContent";
import {useMultipleTabSetting} from "@/hooks/setting/useMultipleTabSetting";
import {usePageFlush} from "@/hooks/setting/usePageFlush";
const {prefixCls} = useDesign('military');

const { t }=useI18n();

const {getFullContent} = useFullContent();
const {getShowMultipleTab} = useMultipleTabSetting();
const getShowTabs = computed(() => {
  return unref(getShowMultipleTab) && !unref(getFullContent);
});

const props=defineProps({
  settingLayout:{
    type:Boolean,
    default:true
  }
})

const menuStore = useMenuStore();
const {
  menuProps
}:any = storeToRefs(menuStore)

const clickHandler = function(e) {
  const target1 = e.target.closest(".vben-left-menu-icon");
  const target2 = e.target.closest(".open-menu");
  if(target1==null&&target2==null){
    unref(menuProps).showMenu=false;
  }
  console.log('body 被点击了');
};

onUnmounted(()=>{
  document.body.removeEventListener('click', clickHandler);
})

onMounted(()=>{
  if(!(document.body.className.indexOf('military-body')>=0)){
    document.body.className=document.body.className+" military-body";
  }
  document.body.addEventListener('click', clickHandler);
})

//刷新界面的hook
usePageFlush();

</script>

<style type="text/css" lang="less">
@import './less/military.less';

.military {
  font-family: "Poppins", "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, "Heiti SC";
}

.wrapper-horizontal.military {
  position: relative;
  .console-base-pane-main{
    z-index: 98;
    //border-top: 1px solid #eee;
    min-width: 490px;
    max-width: 980px;
    overflow: hidden;

    position: absolute;
    top:calc(var(--header-height,62px) + 2px);
    bottom: 0px;
    left: 0px;
    font-size: var(--base-font-size,14px);
    transform: translateX(-100%);
    transition: all 300ms ease-in-out 0s;
    box-shadow: 1px 0 2px 0 var(--cb-color-shadow,rgba(0,0,0,0.16));
    background-color: var(--cb-color-bg-primary,#fff);
    &.open-menu{
      transform: translateX(240px);
    }
  }

  .enter-done{
    top:calc(var(--header-height,62px) + 2px);
    //border-top: 1px solid #eee;
    z-index: 99;
    height:100%;
    display: flex;
    flex-direction: column;
    width: 240px;
    border-right: 1px solid #eee;
    box-shadow: 1px 0 2px 0 var(--cb-color-shadow,rgba(0,0,0,0.16));

    position: absolute;
    bottom: 0px;
    left: 0px;
    font-size: var(--base-font-size,14px);
    transform: translateX(-100%);
    transition: all 300ms ease-in-out 0s;
    background-color: var(--cb-color-bg-primary,#fff);

    &.open-menu{
      transform: translateX(0px);
    }
  }



  transition: all .3s;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  font-size: 18px;

  .page-content{
    width:100%;
    margin-top:var(--header-height,62px);
    height:calc(100% - var(--header-height,62px));
    &.hasTabs{
      .main-panel{
        height:calc(100% - 30px);
      }
    }
  }

  .divider {
    margin-left: 0;
    margin-top: 6px;
    margin-bottom: 6px;
    height: 18px;
  }

  .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 1em;
    margin: 0 8px;
    vertical-align: middle;
    position: relative;
    border-left: 1px var(--el-border-color) var(--el-border-style);
  }
}
</style>
